export const defaultHashtagCategories = Object.freeze({
    GENERAL: {
        fr: 'Général',
        en: 'General',
    },
    LOCATION: {
        fr: 'Localisation',
        en: 'Location',
    },
});

export enum HashtagType {
    RESTAURANT = 'restaurant',
    DESCRIPTION = 'description',
    UNKNOWN = 'unknown',
}
